import {isString} from 'lodash';
import React, {Fragment, memo, ReactNode} from 'react';

import {intersperse} from '../../../../../libs/shared/core/src/helpers/utilities/arrayHelpers';

/*
 * Constants.
 */

const lineBreakRegexp = /<br *\/?>|\r\n|\r|\n/i;

/*
 * Props.
 */

interface SideFrameDialogMessageProps {
  children: string;
}

/*
 * Component.
 */

/* eslint react/no-array-index-key: 0 */
export const SideFrameDialogMessage = memo<SideFrameDialogMessageProps>(({children}) => {
  const textParts = children.split(lineBreakRegexp).filter(isString);
  const textPartsWithNewLines = intersperse<ReactNode>(textParts, <br />);
  return (
    <>
      {textPartsWithNewLines.map((part, index) => (
        <Fragment key={index}>{part}</Fragment>
      ))}
    </>
  );
});
